module.exports = __webpack_public_path__ + "static/media/g-playBtn.3b99b8d5.png";